/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect, Fragment } from "react";
import {
  CModal,
  CModalBody,
  CRow,
  CTabContent,
  CTabPane,
  CTabs,
} from "@coreui/react";
// Redux
import { useDispatch } from "react-redux";


// Otros componentes
import { sha256 } from "js-sha256";
import "../login/login.css";
import { Terminos } from "../login/Terminos";
import Axios2 from "src/config/axios2v";
import { Downloading } from "src/reusable/Spinner";
import swal from "sweetalert";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { RegisterStep1 } from "./FormularioRegistro/RegisterStep1";
import { RegisterStep2 } from "./FormularioRegistro/RegisterStep2";
import { RegisterStep0 } from "./FormularioRegistro/RegisterStep0";
import { RegisterStep3 } from "./FormularioRegistro/RegisterStep3";
import moment from "moment";
import { RegisterStep4 } from "./FormularioRegistro/RegisterStep4";
import { RegisterStep5 } from "./FormularioRegistro/RegisterStep5";
import { RegisterStep6 } from "./FormularioRegistro/RegisterStep6";

const Register = ({ props }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [active, setActive] = useState(false);
  const [Code, setCode] = useState("");
  const [enviando, setenviando] = useState(false);
  const [registrando, setRegistrando] = useState(false);
  const [registrado, setRegistrado] = useState(false);
  const [step, setStep] = useState(0)
  // State local
  const [DataForm, setDataForm] = useState({
    step: 0,
    estado: 0,
    pais: 0,
    rncvalid: false,
    rnc: '',
    constitucion: moment().format('YYYYMMDD'),
    provincia: 'Seleccione',
    municipio: 'Seleccione',
    nombre: "",
    nombrecomercial: '',
    telefono: "",
    direccion: "",
    mail: "",
    password: "",
    datname: "",
    usuario: {
      correo: "",
      password: '',
      password2: ''
    },
    representante: {
      cedula: '',
      nombre: '',
      fechanacimiento: moment().format('YYYYMMDD'),
      whatsapp: '',
      telefono: '',
      correo: '',
      cargo: ''
    }
  });

  const tipodocumento = [
    {
      pais: 1,
      label: 'R.N.C.'
    },
    {
      pais: 2,
      label: 'N.I.T.'
    },
    {
      pais: 3,
      label: 'R.T.N.'
    },
    {
      pais: 100,
      label: 'No. de Registro Empresa'
    }
  ]

  const ConfirmarCorreoOTP = async () => {
    return new Promise((resolve, reject) => {
      // Validacion
      if (
        DataForm.usuario.correo.trim() === "" ||
        DataForm.usuario.password.trim() === "" ||
        DataForm.nombre.trim() === "" ||
        DataForm.representante.nombre.trim() === ""
      ) {
        swal({
          icon: "warning",
          title: "Campos Requeridos !",
          text: `Tos los campos son necesarios`,
          buttons: "Aceptar",
        });

        return;
      }





      setenviando(true);
      Axios2.post("/auth/Register/code", {
        ...DataForm,
        mail: DataForm.usuario.correo,
      })
        .then(({ data }) => {
          setCode(data.code);
          setActive(true);
          setenviando(false);
          resolve()
        })
        .catch((error) => {
          setRegistrando(false);
          setenviando(false);
          reject();
          swal(
            `Error ${error.response.status.toString()}`,
            `${error.response.data}  `,
            "warning"
          );
        });
    })
  };

  const RegisterSend = async (e) => {
    return new Promise(async (resolve, reject) => {

      setActive(false);
      setRegistrando(true);
      let encryptedPassword = sha256(DataForm.usuario.password).toString();

      await Axios2.post("/auth/Register", {
        ...DataForm,
        usuario: {
          ...DataForm.usuario,
          password: encryptedPassword,
        }
      })
        .then(() => {
          setRegistrando(false);
          setRegistrado(true);
          resolve()
        })
        .catch((error) => {
          setRegistrando(false);
          reject()
          swal(
            `Error ${error.response.status.toString()}`,
            `${error.response.data}  `,
            "warning"
          );
        });
    })
  };
  useEffect(() => {
    const loginElement = document.getElementById("logins");

    const script = document.createElement("script");

    script.src = "https://static.coopsys.app/js/facebook.js";
    script.async = true;

    loginElement.appendChild(script);
  }, []);

  const limpiar = (value) => {
    if (value === null) {
      return "";
    }

    var result = "";
    var characters = "Ñ0123456789!&*()-/ ";

    for (let i = 0; i < value.length; i++) {
      if (!characters.includes(value[i])) {
        result += value[i];
      }
    }

    return result;
  };
  const handleChange = (e) => {
    if (e.target.name === 'rnc') {
      setDataForm({
        ...DataForm,
        [e.target.name]: e.target.value,
        rncvalid: false,
      });
    } else {
      setDataForm({
        ...DataForm,
        [e.target.name]: e.target.value,
      });
    }

  };



  return (
    <Fragment>
      {registrando && <Downloading value="Registrando" />}

      <CModal
        show={true}
        onClose={() => history.push('/')}
        centered
        closeOnBackdrop={false}
        size="xl"
      >
        <Fragment>
          <CModalBody style={{
            paddingTop: 50, minHeight: 795.60,

            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f6f8fa',
            padding: '20px',
            color: '#333',

          }}>
            <CTabs
              activeTab={DataForm.step}
            >
              <CTabContent>
                {/* Datos de Solicitud de Prestamo  */}
                <CTabPane>
                  <RegisterStep0 handleChange={handleChange} DataForm={DataForm} onCancel={() => history.push('/')} onSuccess={() => handleChange({ target: { name: 'step', value: 1 } })} />
                </CTabPane>
                <CTabPane>
                  <RegisterStep1
                    handleChange={handleChange}
                    DataForm={DataForm}
                    setDataForm={setDataForm}
                    tipodocumento={tipodocumento.filter(f => f.pais === DataForm.pais)[0]}
                    onCancel={() => handleChange({ target: { name: 'step', value: 0 } })}
                    onSuccess={() => handleChange({ target: { name: 'step', value: 2 } })} />
                </CTabPane>
                <CTabPane>
                  <RegisterStep2 handleChange={handleChange} DataForm={DataForm} setDataForm={setDataForm} onCancel={() => handleChange({ target: { name: 'step', value: 1 } })} onSuccess={() => handleChange({ target: { name: 'step', value: 3 } })} />
                </CTabPane>
                <CTabPane>
                  <RegisterStep3 handleChange={e => {
                    handleChange({
                      target: {
                        name: 'representante',
                        value: {
                          ...DataForm.representante,
                          [e.target.name]: e.target.value
                        }
                      }
                    })
                  }}
                    DataForm={DataForm.representante}
                    pais={DataForm.pais} setDataForm={setDataForm} onCancel={() => handleChange({ target: { name: 'step', value: 2 } })}
                    onSuccess={() => {
                      setDataForm({
                        ...DataForm,
                        'step': 4,
                        usuario: {
                          ...DataForm.usuario,
                          correo: DataForm.representante.correo
                        }
                      })
                    }} />
                </CTabPane>
                {/* Creamos usuarios */}
                <CTabPane>
                  <RegisterStep4 handleChange={e => {
                    handleChange({
                      target: {
                        name: 'usuario',
                        value: {
                          ...DataForm.usuario,
                          [e.target.name]: e.target.value
                        }
                      }
                    })
                  }} DataForm={DataForm.usuario} setDataForm={setDataForm}
                    onCancel={() => handleChange({ target: { name: 'step', value: 3 } })}
                    onSuccess={() => {
                      // validamos que el correo sea correcto mediante OTP 
                      ConfirmarCorreoOTP()
                        .then(() => handleChange({ target: { name: 'step', value: 5 } }))
                        .catch((error) => { })

                    }} />
                </CTabPane>

                {/* Validamos el Codigo OTP del usuarios */}
                <CTabPane>
                  <RegisterStep5 handleChange={e => {
                    handleChange({
                      target: {
                        name: 'usuario',
                        value: {
                          ...DataForm.usuario,
                          [e.target.name]: e.target.value
                        }
                      }
                    })
                  }}
                    DataForm={DataForm.usuario}
                    code={Code}
                    setDataForm={setDataForm}
                    onCancel={() => handleChange({ target: { name: 'step', value: 4 } })}
                    onSuccess={() => {
                      // validamos que el correo sea correcto mediante OTP 
                      RegisterSend()
                        .then(() => handleChange({ target: { name: 'step', value: 6 } }))
                        .catch((error) => { })

                    }} />
                </CTabPane>
                <CTabPane>
                  <RegisterStep6
                    DataForm={DataForm}
                    code={Code}
                    setDataForm={setDataForm}
                    onCancel={() => history.push('/login')}
                    onSuccess={() => window.location.href = 'https://coopsys.com.do/'} />
                </CTabPane>


              </CTabContent>
            </CTabs>

          </CModalBody>
        </Fragment>
      </CModal >

      <div className="main-section-blanco-container">
        <section className="main-section-blanco" id="logins">
          {/* <div className="login-section-banner">
          <CImg
            src="/img/bannerlogin.svg"
            // src="https://nomina.alegra.com/electronic-payroll-assets/img/login-sidebar.de6d3723.svg"
          />
        </div> */}
          <div className="flex flex-column align-center justify-start register">
            <CRow
              className="flex flex-row justify-between align-center"
              style={{
                width: "100%",
                height: "fit-content",
                padding: "20px 30px",
              }}
            >



            </CRow>

            <div className="flex flex-column align-center register-section">
              <div className="register-wrapper">



              </div>
            </div>
          </div>
          <div id="fb-root"></div>
          <div id="fb-customer-chat" className="fb-customerchat"></div>
        </section>
      </div>

      {/* <ValidarMail
        mail={DataForm.mail}
        code={Code}
        active={active}
        Close={() => setActive(false)}
        Validado={() => {
          RegisterSend(DataForm);
        }}
      /> */}
      {/* <Registrado
        show={registrado}
        DataForm={DataForm}
        Close={() => {
          setRegistrado(false);
        }}
      /> */}
      <Terminos />
    </Fragment >
  );
};

export default Register;
